import { Action } from '@ngrx/store';

export enum PaginationActionTypes {
  INITIALIZE_PAGINATION = '[Pagination] Initialize',
  SET_UP_PAGINATION = '[Pagination] Set up',
  SET_CURRENT_PAGE = '[Pagination] Set Current Page'
}

export class InitializePaginationAction {
  readonly type = PaginationActionTypes.INITIALIZE_PAGINATION;
  constructor(public payload: any) {}
}
export class SetUpPaginationAction implements Action {
  readonly type = PaginationActionTypes.SET_UP_PAGINATION;
  constructor(public payload: any) {}
}

export class SetCurrentPageAction implements Action {
  readonly type = PaginationActionTypes.SET_CURRENT_PAGE;
  constructor(public payload: any) {}
}

export type PaginationActions =
  | InitializePaginationAction
  | SetUpPaginationAction
  | SetCurrentPageAction;
